import angular from 'angular';

angular
  .module('cxRegistrations')
  .controller('NewSubResourceDialogCtrl', [
    '$element',
    'resourceFactorySvc',
    'flySvc',
    'close',
    'dataCache',
    'category',
    newSubResourceDialogCtrl,
  ]);

function newSubResourceDialogCtrl(
  $element,
  resourceFactorySvc,
  flySvc,
  close,
  dataCache,
  category,
) {
  var vm = this;
  vm.showValidation = false;
  vm.category = category;
  vm.translation = {};
  vm.resource = {
    categoryId: category.id,
    code: null,
    name: '',
    inForfait: category.resource ? !!category.resource.inForfait : true,
    isBillable: category.resource ? !!category.resource.isBillable : true,
    enabledOnAllAssignments: true,
  };
  vm.showAssignments = dataCache.getArray('assignmentsEnabled');
  var regResource = resourceFactorySvc.get('resource');

  vm.save = function() {
    vm.saving = true;
    regResource.saveResource(
      vm.resource,
      function(result) {
        if (result.id && vm.translation && vm.translation.save) {
          vm.translation.save(result.id).then(function() {
            $element.modal('hide');
            close(result, 500);
          });
        } else {
          $element.modal('hide');
          close(result, 500);
        }
      },
      function(error) {
        vm.saving = false;
        flySvc.error(error.data.code, error.data.parameters);
      },
    );
  };

  vm.updateName = function(value) {
    vm.resource.name = value;
  };

  vm.showValidationErrors = function() {
    vm.showValidation = true;
    if (vm.translation && vm.translation.isValid) vm.translation.isValid(true);
  };

  vm.cancel = function() {
    $element.modal('hide');
    close(null, 500);
  };
}
